import React, { useEffect, useMemo, useState } from "react";
import BarChart from "../../../../../components/charts/BarChart";
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import Card from "../../../../../components/card/Card";
import { useTranslation } from "react-i18next";
import { IChartData } from "../../types";
import { barChartOptionsDailyTraffic } from "../../../../../variables/charts";

interface Props {
  data: IChartData;
}

const Graph: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const textColor = useColorModeValue("brand.500", "white");

  const [orderAnalytics, setOrderAnalytics] = useState([
    { name: t("dashboard.totalOrder"), data: data.order },
  ]);

  const [revenueAnalytics, setRevenueAnalytics] = useState([
    { name: t("dashboard.totalIncome"), data: data.payment || [] },
  ]);

  useEffect(() => {
    setOrderAnalytics([{ name: t("dashboard.totalOrder"), data: data.order }]);
    setRevenueAnalytics([
      { name: t("dashboard.totalIncome"), data: data.payment || [] },
    ]);
  }, [data, t]);

  const chartOptions = useMemo(
    () => ({
      ...barChartOptionsDailyTraffic,
      chart: {
        ...barChartOptionsDailyTraffic.chart,
        padding: { top: 40, right: 40, bottom: 40, left: 20 },
        zoom: {
          enabled: true,
          type: "xy",
          zoomedArea: { fill: "#fff", stroke: "#0D47A1", strokeWidth: 1 },
        },
      },
      colors: ["#1e2a78"], // Only one color now
      xaxis: {
        categories: data.date || [],
        labels: { style: { colors: "#8C89B4", fontSize: "12px" } },
      },
      fill: {
        type: "gradient",
        gradient: {
          type: "vertical",
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          colorStops: [[{ offset: 0, color: "#1e2a78", opacity: 1 }]],
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "30%",
          endingShape: "flat",
          borderRadius: 6,
          offsetY: 20,
        },
      },
      yaxis: {
        labels: { style: { colors: "#8C89B4" } },
        axisTicks: { show: true, color: "#8C89B4" },
      },
      tooltip: {
        theme: "light",
        style: {
          fontSize: "13px",
          fontFamily: "Inter, sans-serif",
        },
      },
    }),
    [data.date]
  );

  const renderChart = (title: string, series: any[]) => (
    <Card>
      <Box h="530px" p="20px" borderRadius="20px">
        <Text
          fontSize="28px"
          lineHeight="10"
          color={textColor}
          mb={5}
          fontWeight="bold"
          ml={1}
        >
          {title}
        </Text>
        <Box w="100%" h="87%">
          <BarChart chartData={series} chartOptions={chartOptions} />
          <style>{`.apexcharts-menu-icon { display: none; }`}</style>
        </Box>
      </Box>
    </Card>
  );

  return (
    <Flex direction="row" gap={5}>
      {renderChart(t("dashboard.orderAnalytics"), orderAnalytics)}
      {renderChart(t("dashboard.revenueAnalytics"), revenueAnalytics)}
    </Flex>
  );
};

export default Graph;
